import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import $ from 'jquery';
import { FormGroup, Label, Form, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import { parseValue } from '../utils/Common';
import './catogory.css';
import Table from './common/Table';

const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

const BuyerOrders = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [allOrders, setAllOrders] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [selectedOrderData, setSelectedOrderData] = useState(null);
    const [orderTrackingData, setOrderTrackingData] = useState([]);
    const [showOrderTrackingModal, setShowOrderTrackingModal] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});

    useEffect(() => {
        checkAccess();
    }, []);

    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
            alert("Access Denied");
            navigate("/");
            return;
        } else {
            setUserRights(rights);
            if (!localStorage.getItem('admin_token')) {
                navigate('/login');
            }
            if (!location.state) {
                navigate('/');
            }
            getAllOrders();
        }
    }
    const getAllOrders = async (isExport = 0, limit = 10, offset = 0, search = {}) => {
        let data = {
            'user_id': location.state.id,
            'fromDate': location.state.startDate.length > 0 ? location.state.startDate : $('#Date-from').val(),
            'toDate': location.state.endDate.length > 0 ? location.state.endDate : $('#Date-to').val(),
            'export': isExport,
            'limit': limit,
            'offset': offset
        }
        let response = await common.apiRequest('post', '/orders/get-orders', data);
        if (response && response.data && response.data.code === 'success') {
            setAllOrders(response.data.data);
            const formattedData = response?.data?.data 
            ? response.data.data.flatMap((order) =>                 
                order.order_items.map((orderItem) => ({
                    id : orderItem.id,
                    orderId: order.order_id,
                    userId: order.user.reg_id,
                    sellerId: orderItem.seller.reg_id,
                    saleType: orderItem.product_item ? "Online Product Sale" : orderItem.seller_service ? "Online Service Sale" : "Offline Product Sale",
                    name: orderItem.product_item ? orderItem.product_item.product.name : orderItem.seller_service ? orderItem.seller_service.service_name : "NA",
                    description: orderItem.product_item ? orderItem.product_item.product.description : orderItem.seller_service ? orderItem.seller_service.service_description : "NA",
                    orderPrice: parseValue(orderItem.order_price,'float'),
                    orderQuantity: orderItem.order_quantity,
                    orderStatus: orderItem.order_status,
                    orderDate: orderItem.created_at,
                    orderCompletedOn: orderItem.order_completed_on,
                    orderCancelledOn: orderItem.order_cancelled_on,
                    taxableAmount: parseValue(orderItem.taxable_amount,'float'),
                    taxPercent: parseValue(orderItem.tax_percent,'float'),
                    cgstPercent: parseValue(orderItem.cgst_percent,'float'),
                    cgst: parseValue(orderItem.cgst,'float'),
                    sgstPercent: parseValue(orderItem.sgst_percent,'float'),
                    sgst: parseValue(orderItem.sgst,'float'),
                    igstPercent: parseValue(orderItem.igst_percent,'float'),
                    igst: parseValue(orderItem.igst,'float'),
                    walletAmount: parseValue(orderItem.wallet_amount,'float'),
                    utgstPercent: parseValue(orderItem.utgst_percent,'float'),
                    utgst: parseValue(orderItem.utgst,'float'),
                    trackingNo: orderItem.tracking_no,
                    rnoteNo: orderItem.rnote_no,
                    rnoteType: orderItem.rnote_type,
                    rnoteSupplyType: orderItem.rnote_supply_type,
                    rnoteDate: orderItem.rnote_date,
                    rnoteValue: parseValue(orderItem.rnote_value,'float'),
                    rgstRate: parseValue(orderItem.rgst_rate,'float'),
                    rtaxableValue: parseValue(orderItem.rtaxable_value,'float'),
                    rigstPercent: parseValue(orderItem.rigst_percent,'float'),
                    rigst: parseValue(orderItem.rigst,'float'),
                    rcgstPercent: parseValue(orderItem.rcgst_percent,'float'),
                    rcgst: parseValue(orderItem.rcgst,'float'),
                    rsgstPercent: parseValue(orderItem.rsgst_percent,'float'),
                    rsgst: parseValue(orderItem.rsgst,'float'),
                    rutgstPercent: parseValue(orderItem.rutgst_percent,'float'),
                    rutgst: parseValue(orderItem.rutgst,'float'),
                    rirn: orderItem.rirn,
                    rirnDate: orderItem.rirn_date,
                    tcs: parseValue(orderItem.tcs,'float'),
                    tcsRate: parseValue(orderItem.tcs_rate,'float'),
                    tigst: parseValue(orderItem.tigst,'float'),
                    tcgst: parseValue(orderItem.tcgst,'float'),
                    tsgst: parseValue(orderItem.tsgst,'float'),
                    tutgst: parseValue(orderItem.tutgst,'float'),
                    taxableBankCharges: parseValue(orderItem.taxable_bank_charges,'float'),
                    bigst: parseValue(orderItem.bigst,'float'),
                    bcgst: parseValue(orderItem.bcgst,'float'),
                    bsgst: parseValue(orderItem.bsgst,'float'),
                    butgst: parseValue(orderItem.butgst,'float'),
                    order_item_photos: orderItem.order_item_photos,
                    order_trackings: orderItem.order_trackings,
                    returnReason: orderItem.return_reason,
                    replaceReason: orderItem.replace_reason,
                    cancelReason: orderItem.cancel_reason,
                    offlineOrder: orderItem?.offline_sale_product_datum,
                    sellerServiceOrder: orderItem?.seller_service,
                    productItemOrder: orderItem?.product_item,
                    cancelNoteNo: orderItem.cancel_note_no || null,
                    cancelNoteType: orderItem.cancel_note_type || null,
                    cancelSupplyType: orderItem.cancel_note_supply_type || null,
                    cancelNoteDate: orderItem.cancel_note_date || null,
                    cancelNoteValue: parseValue(orderItem.cancel_note_value || 0,'float'),
                    cancelGSTRate: orderItem.cancel_gst_rate || 0,
                    cancelTaxableValue: parseValue(orderItem.cancel_taxable_value || 0,'float'),
                    cancelIGST: orderItem.cancel_igst_percent || 0,
                    cancelIGST: parseValue(orderItem.cancel_igst || 0,'float'),
                    cancelCGST: orderItem.cancel_cgst_percent || 0,
                    cancelCGST: parseValue(orderItem.cancel_cgst || 0,'float'),
                    cancelSGST: orderItem.cancel_sgst_percent || 0,
                    cancelSGST: parseValue(orderItem.cancel_sgst || 0,'float'),
                    cancelUTGST: orderItem.cancel_utgst_percent || 0,
                    cancelUTGST: parseValue(orderItem.cancel_utgst || 0,'float'),
                    cancelIRN: orderItem.cancel_irn || 0,
                    cancelIRNDate: orderItem.cancel_irn_date || 0
                }))
            )
            : [];
            setRowData(formattedData);
            setTotalRecords(response.data.totalRecords);
        } else {
            setAllOrders([]);
            setRowData([]);
        }
    }
    
    const handleShowModal = (user,orderData) => {
        setSelectedUser(user);
        setSelectedOrderData(orderData);
        setShowModal(true);
    };
    const handleShowOrderTrackingModal = (orderTrackingData) => {
        setOrderTrackingData(orderTrackingData);
        setShowOrderTrackingModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedUser(null);
        setSelectedOrderData(null);
    };
    const handleCloseOrderTrackingModal = () => {
        setShowOrderTrackingModal(false);
        setOrderTrackingData([]);
    };

    const columns = [
        { header: 'User ID', accessor: 'userId' },
        { header: 'Seller ID', accessor: 'sellerId' },
        { header: 'Order ID', accessor: 'orderId' },
        { header: 'Sale Type', accessor: 'saleType' },
        { header: 'Name/Description', accessor: 'name' },
        { header: 'Description', accessor: 'description' },
        { header: 'Order Price', accessor: 'orderPrice' },
        { header: 'Order Quantity', accessor: 'orderQuantity' },
        { header: 'Order Status', accessor: 'orderStatus' },
        { header: 'Order Status (2)', accessor: 'order_status' },
        { header: 'Order Date', accessor: 'orderDate' },
        { header: 'Order Completed On', accessor: 'orderCompletedOn' },
        { header: 'Order Cancelled On', accessor: 'orderCancelledOn' },
        { header: 'Taxable Amount', accessor: 'taxableAmount' },
        { header: 'Tax Percent', accessor: 'taxPercent' },
        { header: 'CGST Percent', accessor: 'cgstPercent' },
        { header: 'CGST', accessor: 'cgst' },
        { header: 'SGST Percent', accessor: 'sgstPercent' },
        { header: 'SGST', accessor: 'sgst' },
        { header: 'IGST Percent', accessor: 'igstPercent' },
        { header: 'IGST', accessor: 'igst' },
        { header: 'Wallet Amount', accessor: 'walletAmount' },
        { header: 'UTGST Percent', accessor: 'utgstPercent' },
        { header: 'UTGST', accessor: 'utgst' },
        { header: 'Tracking No', accessor: 'trackingNo' },
        { header: 'RNote No', accessor: 'rnoteNo' },
        { header: 'RNote Type', accessor: 'rnoteType' },
        { header: 'RNote Supply Type', accessor: 'rnoteSupplyType' },
        { header: 'RNote Date', accessor: 'rnoteDate' },
        { header: 'RNote Value', accessor: 'rnoteValue' },
        { header: 'RGST Rate', accessor: 'rgstRate' },
        { header: 'RTaxable Value', accessor: 'rtaxableValue' },
        { header: 'RIGST Percent', accessor: 'rigstPercent' },
        { header: 'RIGST', accessor: 'rigst' },
        { header: 'RCGST Percent', accessor: 'rcgstPercent' },
        { header: 'RCGST', accessor: 'rcgst' },
        { header: 'RSGST Percent', accessor: 'rsgstPercent' },
        { header: 'RSGST', accessor: 'rsgst' },
        { header: 'RUTGST Percent', accessor: 'rutgstPercent' },
        { header: 'RUTGST', accessor: 'rutgst' },
        { header: 'RIRN', accessor: 'rirn' },
        { header: 'RIRN Date', accessor: 'rirnDate' },
        { header: 'TCS', accessor: 'tcs' },
        { header: 'TCS Rate', accessor: 'tcsRate' },
        { header: 'TIGST', accessor: 'tigst' },
        { header: 'TCGST', accessor: 'tcgst' },
        { header: 'TSGST', accessor: 'tsgst' },
        { header: 'TUTGST', accessor: 'tutgst' },
        { header: 'Taxable Bank Charges', accessor: 'taxableBankCharges' },
        { header: 'BIGST', accessor: 'bigst' },
        { header: 'BCGST', accessor: 'bcgst' },
        { header: 'BSGST', accessor: 'bsgst' },
        { header: 'BUTGST', accessor: 'butgst' },
        { header: 'Cancel Note No', accessor: 'cancelNoteNo' },
        { header: 'Cancel Note Type', accessor: 'cancelNoteType' },
        { header: 'Cancel Supply Type', accessor: 'cancelSupplyType' },
        { header: 'Cancel Note Date', accessor: 'cancelNoteDate' },
        { header: 'Cancel Note Value', accessor: 'cancelNoteValue' },
        { header: 'Cancel GST Rate', accessor: 'cancelGSTRate' },
        { header: 'Cancel Taxable Value', accessor: 'cancelTaxableValue' },
        { header: 'Cancel IGST', accessor: 'cancelIGST' },
        { header: 'Cancel CGST', accessor: 'cancelCGST' },
        { header: 'Cancel SGST', accessor: 'cancelSGST' },
        { header: 'Cancel UTGST', accessor: 'cancelUTGST' },
        { header: 'Cancel IRN', accessor: 'cancelIRN' },
        { header: 'Cancel IRN Date', accessor: 'cancelIRNDate' },

        {
            header: 'Order Images',
            accessor: 'order_item_photos',
            render: (row) => {
            const photos = row.order_item_photos;
            return photos && photos.length > 0 ? (
                <button className="btn btn-primary btn-sm" onClick={() => handleShowModal(photos, row)}>
                View Images ({photos.length})
                </button>
            ) : null;
            }
        },
        {
            header: 'Order Tracking',
            accessor: 'order_trackings',
            render: (row) => {
            const tracking = row.order_trackings;
            return tracking && tracking.length > 0 ? (
                <button className="btn btn-primary btn-sm" onClick={() => handleShowOrderTrackingModal(tracking)}>
                View Tracking
                </button>
            ) : null;
            }
        }
    ];

    const exportData = rowData.map(data => ({
        "Service Name": data.service_name,
        "User ID": data.userId,
        "Seller ID": data.sellerId,
        "Order ID": data.orderId,
        "Sale Type": data.saleType,
        "Name/Description": data.name,
        "Description": data.description,
        "Order Price": data.orderPrice,
        "Order Quantity": data.orderQuantity,
        "Order Status": data.orderStatus,
        "Order Date": data.orderDate,
        "Order Completed On": data.orderCompletedOn,
        "Order Cancelled On": data.orderCancelledOn,
        "Taxable Amount": data.taxableAmount,
        "Tax Percent": data.taxPercent,
        "CGST Percent": data.cgstPercent,
        "CGST": data.cgst,
        "SGST Percent": data.sgstPercent,
        "SGST": data.sgst,
        "IGST Percent": data.igstPercent,
        "IGST": data.igst,
        "Wallet Amount": data.walletAmount,
        "UTGST Percent": data.utgstPercent,
        "UTGST": data.utgst,
        "Tracking No": data.trackingNo,
        "RNote No": data.rnoteNo,
        "RNote Type": data.rnoteType,
        "RNote Supply Type": data.rnoteSupplyType,
        "RNote Date": data.rnoteDate,
        "RNote Value": data.rnoteValue,
        "RGST Rate": data.rgstRate,
        "RTaxable Value": data.rtaxableValue,
        "RIGST Percent": data.rigstPercent,
        "RIGST": data.rigst,
        "RCGST Percent": data.rcgstPercent,
        "RCGST": data.rcgst,
        "RSGST Percent": data.rsgstPercent,
        "RSGST": data.rsgst,
        "RUTGST Percent": data.rutgstPercent,
        "RUTGST": data.rutgst,
        "RIRN": data.rirn,
        "RIRN Date": data.rirnDate,
        "TCS": data.tcs,
        "TCS Rate": data.tcsRate,
        "TIGST": data.tigst,
        "TCGST": data.tcgst,
        "TSGST": data.tsgst,
        "TUTGST": data.tutgst,
        "Taxable Bank Charges": data.taxableBankCharges,
        "BIGST": data.bigst,
        "BCGST": data.bcgst,
        "BSGST": data.bsgst,
        "BUTGST": data.butgst,
        "Cancel Note No": data.cancelNoteNo,
        "Cancel Note Type": data.cancelNoteType,
        "Cancel Supply Type": data.cancelSupplyType,
        "Cancel Note Date": data.cancelNoteDate,
        "Cancel Note Value": data.cancelNoteValue,
        "Cancel GST Rate": data.cancelGSTRate,
        "Cancel Taxable Value": data.cancelTaxableValue,
        "Cancel IGST": data.cancelIGST,
        "Cancel CGST": data.cancelCGST,
        "Cancel SGST": data.cancelSGST,
        "Cancel UTGST": data.cancelUTGST,
        "Cancel IRN": data.cancelIRN,
        "Cancel IRN Date": data.cancelIRNDate,
    }));
    
    
    const handleExportCSV = () => {
        exportToCSV(exportData, 'buyerorders');
    }

    const handleExportExcel = () => {
        exportToExcel(exportData, 'buyerorders');
    }

    const handleExportPDF = () => {
        exportToPDF(exportData, 'buyerorders');
    }

    return (
        <div>
            <h1>All Orders</h1>
            <div className="col-md-12">
                <Form className='row'>
                    <FormGroup className='col-md-4 row'>
                        <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                        <Input type='date' defaultValue={location.state.startDate.length > 0 ? location.state.startDate : moment().startOf('month').format('YYYY-MM-DD')}   onChange={(e) => getAllOrders(0)}  className="form-control col-md-5" id="Date-from" name="Date-from"></Input>
                    </FormGroup>
                    <FormGroup className='col-md-4 row'>
                        <Label className="col-md-2 col-form-label" for="Date-to">To:</Label>
                        <Input type='date' defaultValue={location.state.endDate.length > 0 ? location.state.endDate : moment().endOf('month').format('YYYY-MM-DD')}   onChange={(e) => getAllOrders(0)}  className="form-control col-md-5" id="Date-to" name="Date-to"></Input>
                    </FormGroup>
                </Form>
            </div>
            <div className="mb-4">
                <button className='btn button-product mr-2' onClick={handleExportCSV}>Export to CSV</button>
                <button className='btn button-product mr-2' onClick={handleExportExcel}>Export to Excel</button>
                <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
            </div>
            
            <div className="ag-theme-quartz" style={{ height: 600, width: '100%' }}>
                <Table 
                    columns={columns}
                    data={rowData}
                    totalRecords={totalRecords}
                    pageSize={10}
                    onPageChange = {getAllOrders}
                />
            </div>
            <Modal isOpen={showModal} toggle={handleCloseModal} size="lg">
                <ModalHeader toggle={handleCloseModal}>Order Images</ModalHeader>
                <ModalBody>
                    {selectedUser && selectedUser.map((photo, index) => {
                        let imageLabel = '';
                        switch(photo.type) {
                            case 'seller_order':
                                imageLabel = 'Seller Order Image';
                                break;
                            case 'user_return':
                                imageLabel = 'Return Image';
                                break;
                            case 'user_cancel':
                                imageLabel = 'Cancellation Image';
                                break;
                            case 'user_replace':
                                imageLabel = 'Replacement Image';
                                break;
                            case 'deliver_order':
                                imageLabel = 'Delivery Image';
                                break;
                            default:
                                imageLabel = 'Order Image';
                        }
                        
                        return (
                            <div key={index} className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6 className="mb-0">{imageLabel}</h6>
                                    {selectedOrderData && (
                                        <>
                                            {photo.type === 'user_return' && <h6 className="mb-0">Return Reason: {selectedOrderData.returnReason}</h6>}
                                            {photo.type === 'user_replace' && <h6 className="mb-0">Replace Reason: {selectedOrderData.replaceReason}</h6>}
                                            {photo.type === 'user_cancel' && <h6 className="mb-0">Cancel Reason: {selectedOrderData.cancelReason}</h6>}
                                        </>
                                    )}
                                    <small className="text-muted">Uploaded by: {photo.uploaded_via}</small>
                                </div>
                                <div className="border rounded p-2">
                                    <img
                                        src={envConfig.api_url + photo.photo}
                                        style={{ width: '100%', height: 'auto', maxHeight: '400px', objectFit: 'contain' }}
                                        alt={imageLabel}
                                    />
                                </div>
                                {photo.description && (
                                    <p className="mt-2 text-muted small">{photo.description}</p>
                                )}
                            </div>
                        );
                    })}
                    {(!selectedUser || selectedUser.length === 0) && (
                        <div className="text-center text-muted">
                            No images available for this order
                        </div>
                    )}
                </ModalBody>
            </Modal>
            <Modal isOpen={showOrderTrackingModal} toggle={handleCloseOrderTrackingModal} size="lg">
                <ModalHeader toggle={handleCloseOrderTrackingModal}>Order Tracking</ModalHeader>
                <ModalBody>
                                    {
                                        orderTrackingData ? orderTrackingData.map((track) => {
                                            if (track.status == 'cancel_requested') {
                                                return (
                                                    <div className="order-track-step">
                                                        <div className="order-track-status">
                                                            <span className="order-track-status-dot"></span>
                                                            <span className="order-track-status-line"></span>
                                                        </div>
                                                        <div className="order-track-text">
                                                            <p className="order-track-text-stat">{track.remarks.replaceAll("_", " ")}</p>
                                                            <span className="order-track-text-sub">{track.created_at}</span>
                                                        </div>
                                                    </div>
                                                );
                                            } else {
                                                return (
                                                    <div className="order-track-step">
                                                        <div className="order-track-status">
                                                            <span className="order-track-status-dot"></span>
                                                            <span className="order-track-status-line"></span>
                                                        </div>
                                                        <div className="order-track-text">
                                                            <p className="order-track-text-stat">{track.remarks.replaceAll("_", " ")}</p>
                                                            <span className="order-track-text-sub">{track.created_at}</span>
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        }) : ""
                                    }
                </ModalBody>
            </Modal>
        </div>
    );
}

export default BuyerOrders;